import { detectOverflow } from "@floating-ui/react";
import { APP_BAR_HEIGHTS } from "@styles/themes";

const PAGE_OFFSET = 8;

export const pageOverflowMiddleware = {
  name: "pageOverflow",
  async fn(state) {
    const overflow = await detectOverflow(state);
    if(overflow.bottom > PAGE_OFFSET)
      state.y -= overflow.bottom + PAGE_OFFSET;
    
    if(overflow.top + APP_BAR_HEIGHTS.LARGE + PAGE_OFFSET > 0)
      state.y += overflow.top + APP_BAR_HEIGHTS.LARGE + PAGE_OFFSET;
    
    return state;
  },
};